import React, { useContext, useEffect, useState } from "react";
import { MdEmail, MdLocationOn, MdPhone } from "react-icons/md";
import { FaTransgender } from "react-icons/fa";
import Book from "../components/Books/Book";
import Title from "../components/Title";
import ScreenLoader from "../components/Skeleton/ScreenLoader";
import { useQuery } from "react-query";
import { API, publicUrl } from "../config/api";
import { LoginContext } from "../context/loginContext";
import ProfilePictureModal from "../components/Modal/ProfilePictureModal";
import userImageMen from "../assets/image/men-user-default.png";
import userImageWomen from "../assets/image/women-user-default.png";
import NoData from "../components/Skeleton/NoData";
import Pagination from "../components/Pagination/Pagination";

function Profile(props) {
  const [page, setpage] = useState(1);
  // eslint-disable-next-line
  const {
    isLoading,
    error,
    data: bookData,
    refetch,
  } = useQuery("getBooksProfile", () =>
    API.get(`/userbooks?page=${page}&limit=8`)
  );
  const [state] = useContext(LoginContext);
  const [show, setshow] = useState(false);
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setpage(selectedPage + 1);
  };

  useEffect(() => {
    setpage(page);
    refetch();
  }, [page]);
  return (
    <>
      <div>
        {/* container header */}
        <Title name="Profile" />
        <div
          className="w-full rounded-md mb-12"
          style={{ backgroundColor: "#FDEDE6" }}
        >
          <div className="flex flex-col items-center lg:flex-row-reverse px-10">
            {/* right col */}
            <div className="lg:w-4/12 w-full py-8">
              <div className="flex flex-col items-center">
                <div className="mb-4">
                  {!state.user.img || state.user.img === null ? (
                    <img
                      className="w-4/5 rounded-md mx-auto"
                      src={
                        state.user.gender === "male"
                          ? userImageMen
                          : userImageWomen
                      }
                      alt=""
                    />
                  ) : (
                    <img
                      className="w-4/5 rounded-md mx-auto"
                      src={publicUrl + "/" + state.user.img}
                      alt=""
                    />
                  )}
                </div>
                <div className="items-center">
                  <button
                    className="w-full px-4 py-2 bg-orange-custom focus:outline-none text-white rounded-md"
                    onClick={() => setshow(!show)}
                  >
                    Change Photo Profile
                  </button>
                </div>
              </div>
            </div>
            {/* left col */}
            <div className="lg:w-8/12 w-full py-10">
              <div className="flex flex-col w-full">
                <div>
                  <div className="flex flex-row mb-6 w-full">
                    <div className="text-3xl mr-3 place-self-center text-gray-600">
                      <MdEmail />
                    </div>
                    <div className="text-sm">
                      <p className="font-extrabold leading-4 ">
                        {state.user.email}
                      </p>
                      <p className="text-gray-600">Email</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex flex-row mb-6 w-full">
                    <div className="text-3xl mr-3 place-self-center text-gray-600">
                      <FaTransgender />
                    </div>
                    <div className="text-sm">
                      <p className="font-extrabold leading-4 ">
                        {state.user.gender}
                      </p>
                      <p className="text-gray-600">Gender</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex flex-row mb-6 w-full">
                    <div className="text-3xl mr-3 place-self-center text-gray-600">
                      <MdPhone />
                    </div>
                    <div className="text-sm">
                      <p className="font-extrabold leading-4 ">
                        {state.user.phone}
                      </p>
                      <p className="text-gray-600">Phone</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex flex-row mb-6 w-full">
                    <div className="text-3xl mr-3 place-self-center text-gray-600">
                      <MdLocationOn />
                    </div>
                    <div className="text-sm">
                      <p className="font-extrabold leading-4 ">
                        {state.user.address}
                      </p>
                      <p className="text-gray-600">Location</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {/* Library */}
          <div className="flex place-content-between">
            <Title name="My Books" />
            <div className=""></div>
          </div>
          {/* card */}
          <div>
            {isLoading || !bookData ? (
              <ScreenLoader />
            ) : error ? (
              <p>{error.message}</p>
            ) : bookData.data.data.length === 0 ? (
              <NoData />
            ) : (
              <>
                <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-8 md:gap-10">
                  {bookData.data.data.map((book, index) => (
                    <Book
                      active={book.status === "Approved" ? "true" : "false"}
                      key={index}
                      data={book}
                    />
                  ))}
                </div>
                <div className="flex w-full justify-center mt-24">
                  <Pagination
                    handleChangePage={handlePageClick}
                    pageCount={bookData.data.totalPages}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <ProfilePictureModal handleProfile={() => setshow(!show)} show={show} />
    </>
  );
}

export default Profile;
